const newsContainer = $('#news');
const newsSettings = $('#news__settings');
const settingsPanel = $('#settings__settings-panel');

let settingsPanelOpen, shareLocation, newsNotifications, shareFacialReactions, subscribed;
settingsPanelOpen = false;
shareLocation = true;
newsNotifications = true;
shareFacialReactions = true;
subscribed = true;

const newsSettingsEvents = new EventDelegator([
    {
        selector: '#js-app',
        eventType: 'click',
        events:
            {
                newssettingspanel: (e, d) =>
                {
                    displaySettingsPanel((d.newssettingspanel === 'toggle'));
                },
                unsubscribe: (e, d) =>
                {
                    unsubscribe(e, d);
                }
            }
    }, {
        selector: '#js-app',
        eventType: 'change',
        events: {
            togglenewsoption: (e, d) =>
            {
                toggleNewsOption(d.togglenewsoption);

                const target = $(e.target).parents('.news-options__switch');
                if ($(e.target).prop('checked') === false) {
                    addToCheckout(d.togglenewsoption, target);
                } else {
                    removeFromCheckout(d.togglenewsoption, target);
                }
            }
        }
    }]);

function toggleNewsOption(target)
{
    shareFacialReactions = (target === 'shareFacialReactions') ? !shareFacialReactions : shareFacialReactions;
    newsNotifications = (target === 'newsNotifications') ? !newsNotifications : newsNotifications;
    shareLocation = (target === 'shareLocation') ? !shareLocation : shareLocation;
    subscribed = (target === 'subscription') ? !subscribed : subscribed;

    shareFacialReactions ? $('[data-news-option="shareFacialReactions"]').addClass('option-indicator--on') : $('[data-news-option="shareFacialReactions"]').removeClass('option-indicator--on');
    newsNotifications ? $('[data-news-option="newsNotifications"]').addClass('option-indicator--on') : $('[data-news-option="newsNotifications"]').removeClass('option-indicator--on');
    shareLocation ? $('[data-news-option="shareLocation"]').addClass('option-indicator--on') : $('[data-news-option="shareLocation"]').removeClass('option-indicator--on');
    subscribed ? $('[data-news-option="subscription"]').addClass('option-indicator--on') : $('[data-news-option="subscription"]').removeClass('option-indicator--on');
}

function displaySettingsPanel(toggle)
{
    settingsPanelOpen = toggle ? settingsPanelOpen : false;
    settingsPanelOpen ? settingsPanel.slideUp() : settingsPanel.slideDown();
    settingsPanelOpen ? newsContainer.removeClass('news--panel-open') : newsContainer.addClass('news--panel-open');
    settingsPanelOpen = !settingsPanelOpen;
}

function unsubscribe(e, d)
{
    const input = $('#unsubscribe__email-input');
    const val = input.val();
    if (val === '' || !val.includes('@'))
    {
        input.addClass('unsubscribe__email-input--error shake');
        setTimeout(function ()
        {
            input.removeClass('shake');
        }, 1000);
    }
    else
    {
        $('#settings-panel__unsubscribe').addClass('settings-panel__unsubscribe--unsubscribed');
        toggleNewsOption('subscription');
        addToCheckout(d.unsubscribe, e.target);
    }
}

function resetUnsubscribeInput()
{
    $('#unsubscribe__email-input').removeClass('unsubscribe__email-input--error shake');
}